module.exports = __webpack_public_path__ + "img/footer_logo.1affd7a3.png";